import { Dialog } from "primereact/dialog"
import GpraCardDetail from "./GpraCardDetail"
import { useEffect } from "react"
import { useState } from "react"
import { useContext } from "react"
import { UserContext } from "../../../context/userContext"
import { gpraUrl } from "../../../config/microservicesUrls"
import axios from "axios"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { LoaderMedium } from "../../../components/Loaders"
import GpraHistorySummary from "./GpraHistorySummary"
import { GpraContext } from "../../../context/gpraContext"

const GpraHistoryDetail = ({ gpra_record, visible, setVisible }) => {
  const { organization_id } = useContext(UserContext)
  const { setQuestions } = useContext(GpraContext)
  const [loading, setLoading] = useState(false)
  const [interviewStatus, setInterviewStatus] = useState()
  const [showSummary, setShowSummary] = useState(false)
  const [interviewType, setInterviewType] = useState()
  const userCtx = useContext(UserContext)
  useEffect(() => {
    if (
      gpra_record?.gpraRecord?.gpraParticipantUuid &&
      gpra_record?.gpraRecord?.gpraMembershipUuid
    ) {
      setLoading(true)
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokens.getGpraToken()}`,
        },
        params: {
          gpra_participant_uuid: gpra_record?.gpraRecord?.gpraParticipantUuid,
          gpra_membership_uuid: gpra_record?.gpraRecord?.gpraMembershipUuid,
          interview_type: interviewType,
        },
      }
      axios
        .get(`${gpraUrl()}${endpoints.INTERVIEW_STATUS}`, config)
        .then((response) => {
          if (response.status === 200) {
            setInterviewStatus(response.data)
            setLoading(false)
          } else {
            setInterviewStatus()
            setLoading(false)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [gpra_record, interviewType])

  useEffect(() => {
    if (organization_id && interviewType) {
      setLoading(true)
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokens.getGpraToken()}`,
        },
      }
      axios
        .post(
          `${gpraUrl()}${endpoints.GET_CUSTOMIZATIONS}`,
          {
            organization_id: organization_id,
            interview_type: interviewType,
            organizations: [],
          },
          config,
        )
        .then((response) => {
          if (response.status === 200) {
            setQuestions(response.data.customizations)
          }
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [organization_id, setQuestions, interviewType])
  return (
    <Dialog
      visible={visible}
      onHide={() => {
        setVisible(false)
        setShowSummary(false)
        setInterviewType("")
      }}
      header={`${interviewType ? interviewType : ""} Interview details`}
      style={{ width: "900px" }}
    >
      {loading ? (
        <LoaderMedium></LoaderMedium>
      ) : showSummary ? (
        <GpraHistorySummary
          gpra_interview_id={interviewStatus?.gpraInterview?.gpraInterviewID}
          interview_type={interviewType}
        />
      ) : (
        <>
          <GpraCardDetail
            loading={false}
            title={"Intake"}
            type={"Intake"}
            completed_date={interviewStatus?.intakeCompletedDate}
            setInterviewType={setInterviewType}
            setShowSummary={setShowSummary}
          />
          <GpraCardDetail
            loading={false}
            title={"Follow Up"}
            type={"FollowUp"}
            completed_date={interviewStatus?.followUpCompletedDate}
            setInterviewType={setInterviewType}
            setShowSummary={setShowSummary}
          />
          <GpraCardDetail
            loading={false}
            title={"Discharge"}
            type={"Discharge"}
            completed_date={interviewStatus?.dischargeCompletedDate}
            setInterviewType={setInterviewType}
            setShowSummary={setShowSummary}
          />
        </>
      )}
    </Dialog>
  )
}
export default GpraHistoryDetail
